import * as angular from 'angular';
import { IQService } from 'angular';
import { bind } from 'app/_decorators/bind.decorator';
import { AuthService } from 'app/_services/auth.service';
import { StorageService } from 'app/_services/storageService';

export class PrivilegeService {
    public static readonly STATUS_CODE = {
        OK: 200,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403
    };

    constructor(
        private $q: IQService,
        private storageService: StorageService,
        private USER_AUTH_FLAG,
        private authService: AuthService
    ) {}

    public hasPrivilege(): angular.IPromise<number> {
        let deferred = this.$q.defer<number>();
        this.authService.userLoginPromise.promise
            .then((user) => {
                if (user) {
                    deferred.resolve(PrivilegeService.STATUS_CODE.OK);
                } else {
                    deferred.reject(PrivilegeService.STATUS_CODE.UNAUTHORIZED);
                }
            })
            .catch(() => {
                deferred.reject(PrivilegeService.STATUS_CODE.UNAUTHORIZED);
            });

        return deferred.promise;
    }

    @bind
    public hasRole(...roles: string[]): angular.IPromise<number> {
        let deferred = this.$q.defer<number>();

        this.authService.userLoginPromise.promise
            .then((user) => {
                if (!user) {
                    deferred.reject(PrivilegeService.STATUS_CODE.UNAUTHORIZED);
                }

                if (roles.some((role) => role == user.role)) {
                    deferred.resolve(PrivilegeService.STATUS_CODE.OK);
                } else {
                    deferred.reject(PrivilegeService.STATUS_CODE.UNAUTHORIZED);
                }
            })
            .catch(() => {
                deferred.reject(PrivilegeService.STATUS_CODE.UNAUTHORIZED);
            });

        return deferred.promise;
    }

    @bind
    public hasNotRole(...roles: string[]): angular.IPromise<number> {
        let deferred = this.$q.defer<number>();

        this.authService.userLoginPromise.promise
            .then((user) => {
                if (!user) {
                    deferred.resolve(PrivilegeService.STATUS_CODE.OK);
                }

                if (roles.some((role) => role == user.role)) {
                    deferred.reject(PrivilegeService.STATUS_CODE.UNAUTHORIZED);
                } else {
                    deferred.resolve(PrivilegeService.STATUS_CODE.OK);
                }
            })
            .catch(() => {
                //guest user
                deferred.resolve(PrivilegeService.STATUS_CODE.OK);
            });

        return deferred.promise;
    }
}

angular.module('app').service('privilegeService', PrivilegeService);
